import { Minus, Plus } from "lucide-react";

type LeverageSelectorProps = {
	marks: number[];
	selectedIndex: number;
	onIndexChange: (index: number) => void;
	formatLabel?: (value: number) => string;
};

function defaultFormat(v: number) {
	return `${v}x`;
}

export function LeverageSelector({
	marks,
	selectedIndex,
	onIndexChange,
	formatLabel = defaultFormat,
}: LeverageSelectorProps) {
	const currentValue = marks[selectedIndex] ?? marks[0];

	function decrement() {
		if (selectedIndex > 0) onIndexChange(selectedIndex - 1);
	}

	function increment() {
		if (selectedIndex < marks.length - 1) onIndexChange(selectedIndex + 1);
	}

	return (
		<div className="grid gap-3">
			{/* Value display with +/- buttons */}
			<div className="flex items-center rounded-[10px] border border-trade-border-subtle bg-trade-surface">
				<button
					type="button"
					onClick={decrement}
					disabled={selectedIndex <= 0}
					className="flex h-10 w-12 cursor-pointer items-center justify-center text-trade-text-secondary transition-colors hover:text-trade-text-strong disabled:cursor-default disabled:opacity-30"
					aria-label="Decrease leverage"
				>
					<Minus className="h-4 w-4" />
				</button>
				<div className="flex-1 text-center text-body1-bold text-trade-text-strong">
					{formatLabel(currentValue)}
				</div>
				<button
					type="button"
					onClick={increment}
					disabled={selectedIndex >= marks.length - 1}
					className="flex h-10 w-12 cursor-pointer items-center justify-center text-trade-text-secondary transition-colors hover:text-trade-text-strong disabled:cursor-default disabled:opacity-30"
					aria-label="Increase leverage"
				>
					<Plus className="h-4 w-4" />
				</button>
			</div>
		</div>
	);
}
